export { default } from './Slider'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Slider/index.js